<ng-container *ngIf="appModeService.isApp(); else webProductDetails">
  <section class="app-product-details" *ngIf="productItem">
    <div class="app-hero">
      <img *ngIf="selectedImage?.imageUrl" [src]="selectedImage.imageUrl" class="app-main-image"
        alt="Main product image" />

      <header class="app-image-header" [class.scrolled]="isScrolled">
        <button type="button" class="icon-btn" (click)="goBackToProducts()">
          <i *ngIf="!isRTL" class="pi pi-arrow-left"></i>
          <i *ngIf="isRTL" class="pi pi-arrow-right"></i>
        </button>
        <div class="header-actions">
          <button type="button" class="icon-btn wishlist-btn" [class.active]="isWishlisted"
            (click)="toggleWishlist($event)">
            <i class="bi" [ngClass]="isWishlisted ? 'bi-heart-fill' : 'bi-heart'"></i>
          </button>
          <button type="button" class="icon-btn" (click)="shareProduct($event)">
            <i class="pi pi-share-alt"></i>
          </button>
        </div>
      </header>
    </div>

    <div class="app-content">
      <h1 class="app-name">{{ productItem?.name }}</h1>

      <div class="app-rating">
        <span class="stars">
          <i class="pi pi-star-fill" *ngFor="let _ of [0,1,2,3,4]"></i>
        </span>
        <span class="rate-text">5.00</span>
      </div>

      <div class="app-prices">
        <span class="current-price">
          {{ convertedPrice | number:'1.2-2' }} {{ getCurrencySymbol() }}
        </span>
        <span class="old-price" *ngIf="productItem?.oldPrice">
          {{ productItem.oldPrice }} {{ getCurrencySymbol() }}
        </span>
      </div>

      <p class="app-description">{{ productItem?.description }}</p>

      <section class="app-select-block">
        <h3>{{ 'PRODUCT.SELECT_COLORS' | translate }}</h3>
        <div class="app-color-list">
          <button type="button" class="app-color-circle" *ngFor="let color of colors"
            [class.app-color-active]="color === selectedColor" [attr.aria-label]="'Select color ' + color"
            (click)="selectColor(color)">
            <span class="app-color-fill" [ngStyle]="{ background: color }">
              <span *ngIf="color === selectedColor" class="app-color-checkmark">&#10003;</span>
            </span>
          </button>
        </div>
      </section>

      <section class="app-select-block">
        <h3>{{ 'PRODUCT.CHOOSE_SIZE' | translate }}</h3>
        <div class="size-grid">
          <button type="button" class="size-card" *ngFor="let size of productItem?.sizes"
            [class.size-card-selected]="isSizeSelected(size)" (click)="toggleSizeSelection(size)">
            {{ size }}
          </button>
        </div>
        <p class="app-empty-sizes" *ngIf="(productItem?.sizes?.length || 0) === 0">
          {{ 'PRODUCT.NO_SIZES_AVAILABLE' | translate }}
        </p>
      </section>

      <section class="app-selected-block" *ngIf="selectedSizes.length > 0">
        <h3>{{ 'Selected Sizes' | translate }}</h3>

        <div class="app-selected-list">
          <div class="app-selected-item" *ngFor="let sizeItem of selectedSizes">
            <div class="app-selected-row">
              <strong>{{ sizeItem.size }}</strong>
              <button type="button" class="app-remove-size-btn" (click)="removeSelectedSize(sizeItem.size)"
                aria-label="Remove size">
                &times;
              </button>
            </div>

            <div class="app-qty-row">
              <button type="button" class="app-qty-btn" (click)="adjustQuantity(sizeItem, -1)">-</button>
              <span class="app-qty-value">{{ sizeItem.quantity }}</span>
              <button type="button" class="app-qty-btn" (click)="adjustQuantity(sizeItem, 1)">+</button>
            </div>

            <div class="app-item-price">
              {{ (sizeItem.quantity * convertedPrice) | number:'1.2-2' }} {{ getCurrencySymbol() }}
            </div>
          </div>
        </div>

        <div class="app-total-box">
          <div class="app-total-row">
            <span>{{ 'Quantity' | translate }}:</span>
            <strong>{{ getTotalQuantity() }}</strong>
          </div>
          <div class="app-total-row app-total-price-row">
            <span>{{ 'Total Price' | translate }}:</span>
            <strong>{{ getTotalPrice() | number:'1.2-2' }} {{ getCurrencySymbol() }}</strong>
          </div>
        </div>
      </section>

      <div class="app-action-buttons">
        <button id="addToCartButton" class="app-order-btn " type="button" (click)="addToCart()"
          [disabled]="selectedSizes.length === 0">
          {{ 'PRODUCT.ADD_TO_CART' | translate }}
        </button>

        <!-- <button id="orderNowButton" class="app-order-btn" type="button" (click)="orderNow()"
          [disabled]="selectedSizes.length === 0">
          {{ 'PRODUCT.ORDER_NOW' | translate }}
        </button> -->
      </div>

      <section class="app-related-section">
        <app-products-component [title]="'PRODUCT.RELATED_PRODUCTS' | translate" [productList]="products">
        </app-products-component>
      </section>
    </div>
  </section>
</ng-container>

<ng-template #webProductDetails>
  <div class="container">
    <div class="mobile-product-details d-md-none" *ngIf="productItem">
      <div class="mobile-image-carousel">
        <div class="mobile-image-slide" *ngFor="let image of productItem?.images || []" (click)="selectImage(image)">
          <img [src]="image?.imageUrl" alt="Product image" />
        </div>
      </div>

      <div class="mobile-product-content">
        <h2 class="mobile-name">{{ productItem?.name }}</h2>
        <h5 class="mobile-price-text">
          {{ convertedPrice | number:'1.2-2' }} {{ getCurrencySymbol() }}
          <span class="text-muted">/piece</span>
        </h5>
        <h5 class="mobile-description">{{ productItem?.description }}</h5>

        <div class="my-3">
          <h5 class="title mb-2">{{ 'PRODUCT.SELECT_COLORS' | translate }}</h5>
          <div class="mobile-color-list">
            <button type="button" class="mobile-color-circle" *ngFor="let color of colors"
              [ngClass]="{ 'mobile-color-active': color === selectedColor }" [attr.aria-label]="'Select color ' + color"
              (click)="selectColor(color)">
              <span class="mobile-color-fill" [ngStyle]="{ background: color }"></span>
            </button>
          </div>
        </div>

        <div class="my-3">
          <h5 class="title mb-2">{{ 'PRODUCT.CHOOSE_SIZE' | translate }}</h5>
          <div class="mobile-size-list">
            <button type="button" class="mobile-size-card" *ngFor="let size of productItem?.sizes"
              [ngClass]="{ 'mobile-size-card-selected': isSizeSelected(size) }" (click)="toggleSizeSelection(size)">
              {{ size }}
            </button>
          </div>
        </div>

        <button id="orderNowButtonMobile" class="btn btn-outline-light btn-sm customize-btn w-100" (click)="orderNow()"
          [disabled]="selectedSizes.length === 0">
          {{ 'PRODUCT.ORDER_NOW' | translate }}
        </button>
      </div>
    </div>

    <div class="row m-0 d-none d-md-flex">
      <div class="col-12 col-md-7 col-lg-6 p-0">
        <div class="row">
          <div class="col-3 d-flex flex-column gap-2" *ngIf="productItem?.images?.length">
            <div class="thumbnail-container">
              <img *ngFor="let image of productItem.images || []" [src]="image?.imageUrl" (click)="selectImage(image)"
                class="img-thumbnail thumb-image mb-2" [class.selected]="image?.imageUrl === selectedImage?.imageUrl"
                alt="Thumbnail" />
            </div>
          </div>

          <div class="col-9">
            <img *ngIf="selectedImage?.imageUrl" [src]="selectedImage.imageUrl" class="img-fluid main-image"
              alt="Main Image" />
          </div>
        </div>
      </div>

      <div class="col-12 col-md-5 col-lg-6 px-3 mt-3 mt-md-0">
        <h2 class="name">{{ productItem?.name }}</h2>

        <div class="d-flex align-items-center gap-2 my-2">
          <h5 class="m-0 price-text">
            {{ convertedPrice | number:'1.2-2' }} {{ getCurrencySymbol() }}
            <span class="text-muted">/piece</span>
          </h5>
        </div>

        <h5 class="description my-3">{{ productItem?.description }}</h5>

        <div class="my-3">
          <h5 class="title mb-2">{{ 'PRODUCT.SELECT_COLORS' | translate }}</h5>
          <div class="d-flex flex-wrap">
            <div class="outer-circle" *ngFor="let color of colors"
              [ngClass]="{ 'color-active': color === selectedColor }" (click)="selectColor(color)">
              <div class="inner-circle" [ngStyle]="{ background: color }">
                <span *ngIf="color === selectedColor" class="checkmark">&#10003;</span>
              </div>
            </div>
          </div>
        </div>

        <div class="my-3">
          <h5 class="title mb-2">{{ 'PRODUCT.CHOOSE_SIZE' | translate }}</h5>
          <div class="d-flex flex-wrap">
            <div id="cardSize" class="size-card" *ngFor="let size of productItem?.sizes"
              [ngClass]="{ 'size-card-selected': isSizeSelected(size) }" (click)="toggleSizeSelection(size)">
              {{ size }}
            </div>
          </div>
        </div>

        <div *ngIf="selectedSizes.length > 0" class="my-4">
          <h6 class="title">{{ 'Selected Sizes' | translate }}</h6>
          <div class="selected-sizes-container">
            <div class="selected-size-item" *ngFor="let sizeItem of selectedSizes">
              <div class="size-info">
                <strong>{{ sizeItem.size }}</strong>
                <span class="remove-icon" (click)="removeSelectedSize(sizeItem.size)">&times;</span>
              </div>
              <div class="quantity-controls">
                <button id="decreaseQuantity" class="btn btn-sm" (click)="adjustQuantity(sizeItem, -1)">âˆ’</button>
                <span class="quantity-display">{{ sizeItem.quantity }}</span>
                <button id="increaseQuantity" class="btn btn-sm" (click)="adjustQuantity(sizeItem, 1)">+</button>
              </div>
              <div class="item-price">
                {{ (sizeItem.quantity * convertedPrice) | number:'1.2-2' }} {{ getCurrencySymbol() }}
              </div>
            </div>
          </div>

          <div class="total-summary">
            <div class="summary-row">
              <span>{{ 'Quantity' | translate }}:</span>
              <strong>{{ getTotalQuantity() }}</strong>
            </div>
            <div class="summary-row total-price">
              <span>{{ 'Total Price' | translate }}:</span>
              <strong>{{ getTotalPrice() | number:'1.2-2' }} {{ getCurrencySymbol() }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4" style="width: 50%;margin: auto;">
        <button id="orderNowButton" class="btn btn-outline-light btn-sm customize-btn w-100" (click)="orderNow()"
          [disabled]="selectedSizes.length === 0">
          {{ 'PRODUCT.ORDER_NOW' | translate }}
        </button>
      </div>
    </div>

    <br><br>
    <app-products-component [title]="'PRODUCT.RELATED_PRODUCTS' | translate" [productList]="products">
    </app-products-component>
  </div>
</ng-template>